<template>
  <div class="speciesSelectMain">
    <img src="@/assets/logo.png" width="300px" />
    <div v-if="!errored" class="ma-4">
      <h2>Select a species</h2>
      <v-row no-gutters fluid>
        <v-col>
          <v-chip
            v-for="species in listOfSpecies"
            :key="species.id"
            class="ma-2 elevation-4"
            label
            large
            @click="$router.push(`/${species.id}/`)"
          >
            {{ species.label }}
          </v-chip>
        </v-col>
      </v-row>
    </div>

    <v-card shaped elevation="5" class="speciesSelect">
      <v-card-text>
        <p class="text-justify">
          The ATLAS project aims at developing a "Big Data" architecture to characterize the
          comprehensive catalog of alleles of cultivated species.
          <br /><br />
          <b>Contributors:</b>
          <a target="_blank" href="http://lipm-bioinfo.toulouse.inrae.fr"> LIPM-BIOINFO team</a>
          <br />
          <b>User interface:</b> Erika Sallet & Ludovic Cottret
          <br />
          <b>Back end & Diversity Analyses:</b> Ludovic Legrand & Sebastien Carrere
          <br />
          <b>Allele assemblies, project management and contact:</b> Jerome.Gouzy@inrae.fr
        </p>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { mapActions } from 'vuex';
import { mapMutations } from 'vuex';

export default {
  data() {
    return {
      errored: false,
    };
  },
  computed: {
    ...mapGetters({
      listOfSpecies: 'getListOfSpecies',
    }),
  },
  created() {
    this.setCurrentSpecies('');
    this.initRelease().then(
      () => {},
      () => {
        this.errored = true;
      }
    );
    this.fetchListOfSpecies().then(
      () => {},
      () => {
        this.errored = true;
      }
    );
  },
  methods: {
    ...mapActions(['fetchListOfSpecies', 'initRelease']),
    ...mapMutations(['setCurrentSpecies']),
  },
};
</script>

<style scoped>
.speciesSelect {
  max-width: 500px;
  margin: auto;
  text-align: center;
}
.speciesSelectMain {
  max-width: 1000px;
  margin: auto;
  text-align: center;
}
button {
  margin: 10px 10px 50px 10px;
}

img {
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: -100px;
}
</style>
